module.exports = __webpack_public_path__ + "static/media/main_image_2.3fe37426.png";